import PageHeader from '../../components/layout/PageHeader';
import AppointmentList from '../../components/scheduling/AppointmentList';

/**
 * Manager's appointments page. Defaults to "All" — sees everything
 * scheduled across the team. Use the "Orphans" chip for triage.
 * Reassignment is the only manager-specific action; cancel is also
 * available.
 */
export default function ManagerAppointments(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Team appointments"
        subtitle="All scheduled calls across the team. Triage orphans and reassign as needed."
      />
      <AppointmentList
        defaultFilters={{}}
        viewerRole="manager"
      />
    </>
  );
}
